const imageContext = require.context('../img', true, /\.(png|jpe?g|gif|svg)$/);

const imageMap = imageContext.keys().reduce((accumulator, key) => {
  const normalizedKey = key.replace('./', '').replace(/\\/g, '/').toLowerCase();
  accumulator[normalizedKey] = imageContext(key);
  return accumulator;
}, {});

const getNormalizedAssetKey = (folder, fileName) => {
  if (!folder || !fileName) {
    return null;
  }

  return `${folder}/${fileName}`.replace(/\\/g, '/').toLowerCase();
};

export const getProjectImage = (project, fileName) => {
  const key = getNormalizedAssetKey(project?.imageFolder, fileName);

  if (!key) {
    return null;
  }

  return imageMap[key] || null;
};

export const getProjectThumbnail = (project) => {
  if (!project) {
    return null;
  }

  if (project.thumbnailFileName) {
    return getProjectImage(project, project.thumbnailFileName);
  }

  const firstImageBlock = project.contentSections
    ?.flatMap(section => section.blocks)
    .find(block => block.type === 'image' && getProjectImage(project, block.fileName || block.label));

  if (!firstImageBlock) {
    return null;
  }

  return getProjectImage(project, firstImageBlock.fileName || firstImageBlock.label);
};